module.exports = __webpack_public_path__ + "img/service_zecon.f99b7b72.png";